Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "COMM001": "参数错误",
    "COMM002": "Token权限错误",
};
